import { CaseOption } from '../ParallelCase';
import HoverMessage from 'common/components/HoverMessage';
import ReactHtmlParser from 'react-html-parser';
import Mobile from './mobile';
import Web from './web';
import withResponsive from 'v3/common/hooks/withResponsive';

export type ResponsiveProps = {
  isShowAddCaseHoverMessage: boolean;
  cases: CaseOption[];
  children: React.ReactNode;
  renderHoverMessage: React.ReactNode;
  renderAddCaseButton: React.ReactNode;
  activeCaseIndex: number;
  onChangeActiveCaseIndex: (index: number) => void;
  isMaximumCasesExceeded: boolean;
  onAddCase: () => void;
  handleDeleteCase: (index: number) => void;
  onCloneCase: (index: number) => void;
  renderCaseIcon: (idx: number) => React.ReactNode;
};
const ResponsiveComponent = withResponsive(Mobile, Web);

let renderMessage = '<b> Please purchase a <b>Pro or Premium plan to use this feature.</b>';
renderMessage += '<img src="/v3Crown.png" class="v2-crown-image" alt="" /></b>';

type AddCaseProps = {
  children: React.ReactNode;
  renderAddCaseButton: React.ReactNode;
  renderCaseIcon: (idx: number) => React.ReactNode;
  handleDeleteCase: (index: number) => void;
  onCloneCase: (index: number) => void;
  isShowAddCaseHoverMessage: boolean;
  cases: CaseOption[];
  activeCaseIndex: number;
  onChangeActiveCaseIndex: (index: number) => void;
  isMaximumCasesExceeded: boolean;
  onAddCase: () => void;
};
const AddCase = ({
  children,
  renderAddCaseButton,
  renderCaseIcon,
  handleDeleteCase,
  onCloneCase,
  isShowAddCaseHoverMessage,
  cases,
  activeCaseIndex,
  onChangeActiveCaseIndex,
  isMaximumCasesExceeded,
  onAddCase,
}: AddCaseProps) => {
  const renderHoverMessage = (
    <HoverMessage
      title="Pro or Premium Plan Required"
      message={ReactHtmlParser(renderMessage)}
      isOpen={isShowAddCaseHoverMessage}
    >
      {renderAddCaseButton}
    </HoverMessage>
  );
  return (
    <div className="add-item-case-container mt-3">
      <ResponsiveComponent
        isShowAddCaseHoverMessage={isShowAddCaseHoverMessage}
        cases={cases}
        renderHoverMessage={renderHoverMessage}
        renderAddCaseButton={renderAddCaseButton}
        activeCaseIndex={activeCaseIndex}
        onChangeActiveCaseIndex={onChangeActiveCaseIndex}
        renderCaseIcon={renderCaseIcon}
        isMaximumCasesExceeded={isMaximumCasesExceeded}
        onAddCase={onAddCase}
        handleDeleteCase={handleDeleteCase}
        onCloneCase={onCloneCase}
      >
        {children}
      </ResponsiveComponent>
    </div>
  );
};

export default AddCase;
